import React, { useEffect, useState } from 'react';
import { Box, MenuItem, Select, SxProps, Theme } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { TaxGroup, useTaxGroups } from '@/core';

type FormDropdownMenuControllerProps = {
  controllerName: string;
  dropdownOnChange?: () => void;
  preSelectedTaxValue?: number | string;
  sx?: SxProps<Theme>;
};

export const FormDropdownMenuController = ({
  controllerName,
  dropdownOnChange,
  preSelectedTaxValue,
  sx,
}: FormDropdownMenuControllerProps) => {
  const { data: taxGroups } = useTaxGroups();
  const { control, setValue } = useFormContext();
  const [selectedTaxGroup, setSelectedTaxGroup] = useState<TaxGroup | undefined>(undefined);

  useEffect(() => {
    if (taxGroups && taxGroups.length > 0) {
      const lastTaxGroup = taxGroups[taxGroups.length - 1];
      const taxGroup = taxGroups.find((g) => g.value === preSelectedTaxValue) || lastTaxGroup;
      setSelectedTaxGroup(taxGroup);
      setValue('taxGroup', lastTaxGroup);
    }
  }, [preSelectedTaxValue, setValue, taxGroups]);

  const handleTaxGroupChange = (taxGroupId: number) => {
    if (!taxGroups) return;
    const taxGroup = taxGroups.find((g) => g.id === taxGroupId) || taxGroups[taxGroups.length - 1];
    setValue('taxGroup', taxGroup);
    setSelectedTaxGroup(taxGroup);
  };

  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field }) => (
        <Box sx={{ width: '100%', ...sx }}>
          <Select
            {...field}
            value={selectedTaxGroup?.id ?? ''}
            onChange={(e) => {
              const taxGroupId = Number(e.target.value);
              handleTaxGroupChange(taxGroupId);
              field.onChange(taxGroupId);
              dropdownOnChange?.();
            }}
            fullWidth
          >
            {taxGroups?.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                {group.value}% DPH
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    />
  );
};
